import { useEmptyFeed } from '@confluence/feed/entry-points/useEmptyFeed.ts';

export const usePostOfficeHomeBannerEligible = () => {
	const { hasFeed } = useEmptyFeed();

	return {
		isEligible: hasFeed,
	};
};
